import mapValues from 'lodash/mapValues';
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var getTypographyTheme = (theme, fontFamily) => {
  /**
   * Copy from `/components/global/tokens/typography/en.ts`
   * In the future, we should maintain one set of typography variables here and not expose them
   * directly to the developers. They can get these variables from theme.
   */
  var {
    breakpoint
  } = theme.breakpoints;
  var {
    greys,
    reds,
    ultraViolets
  } = theme.colors;
  // todo: change all styles below to suit zh
  // - if should be similar to another language's typography (e.g. en), can import whatever parts of that and compose accordingly
  var default_ = {
    fontFamily
  };
  var titleDefaults = {
    color: greys[100],
    fontWeight: 700,
    lineHeight: 1.25
  };
  var titleVariant = {
    "100": {
      fontSize: 40,
      [breakpoint.s]: {
        fontSize: 24
      }
    }
  };
  var headlineDefault = {
    color: greys[100],
    fontWeight: 700,
    lineHeight: 1.25
  };
  var headlineVariant = {
    "100": {
      fontSize: 24
    },
    "200": {
      fontSize: 18
    },
    "300": {
      fontSize: 16
    },
    "400": {
      fontSize: 14
    },
    "500": {
      fontSize: 14,
      fontWeight: 500
    },
    "600": {
      fontSize: 13,
      fontWeight: 500,
      textTransform: "uppercase"
    }
  };
  var bodyDefault = {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: 1.5
  };
  var bodyVariant = {
    "100": {
      color: greys[80]
    },
    "100.Subtle": {
      color: greys[60]
    },
    "100.Disabled": {
      color: greys[40]
    },
    "100.Bold": {
      color: greys[80],
      fontWeight: 500
    }
  };
  var tabPanelDefault = {
    fontWeight: 400,
    color: greys[80],
    lineHeight: 1.25
  };
  var tabPanelVariant = {
    inactive: {
      fontSize: 16
    }
  };
  var labelVariant = {
    "100": bodyVariant["100"]
  };
  var hintVariant = {
    "100": _extends({}, bodyVariant["100.Subtle"], {
      fontSize: 12
    })
  };
  var errorVariant = {
    "100": _extends({}, bodyVariant["100"], {
      fontSize: 12,
      color: reds[50]
    })
  };
  var textLink = {
    fontWeight: 500,
    fontSize: "inherit",
    fontFamily: "inherit",
    colors: {
      disabled: greys[40],
      initial: ultraViolets[70],
      active: ultraViolets[40]
    }
  };
  return {
    title: mapValues(titleVariant, s => _extends({}, default_, titleDefaults, s)),
    headline: mapValues(headlineVariant, s => _extends({}, default_, headlineDefault, s)),
    body: mapValues(bodyVariant, s => _extends({}, default_, bodyDefault, s)),
    tabPanel: mapValues(tabPanelVariant, s => _extends({}, default_, tabPanelDefault, s)),
    label: mapValues(labelVariant, s => _extends({}, default_, bodyDefault, s)),
    hint: mapValues(hintVariant, s => _extends({}, default_, bodyDefault, s)),
    error: mapValues(errorVariant, s => _extends({}, default_, bodyDefault, s)),
    textLink
  };
};
export { getTypographyTheme };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzIjpbXSwic291cmNlc0NvbnRlbnQiOltdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiIn0=
